import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import ProfileEditPage from "../components/cards/ProfileEditPage";
import "./profile.css";
import { MdOutlineVerified, MdHelp, MdCreditCard } from "react-icons/md";
import { RiFileListFill, RiArrowRightSFill } from "react-icons/ri";

import { test_ip } from "../services/constants";

import { setError } from "../services/actions";
import { useDispatch } from "react-redux";

import { toast } from "react-toastify";

function Profile(props) {
  const [users, setUsers] = useState();
  const [edit, setEdit] = useState(false);
  const nav = useNavigate();
  const diapach = useDispatch();

  useEffect(() => {
    var user = JSON.parse(localStorage.getItem("user"));
    var data = {
      user_id: user.user_id,
      server_token: user.server_token,
    };
    Get_User_detail(data);
  }, []);

  const Get_User_detail = function (data) {
    // get user detail
    var body = data;
    body = JSON.stringify(body);
    axios
      .post(`${test_ip}api/user/get_detail`, body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          console.log(res.data);
          if (res.data.success == true) {
            console.log(res.data.user);
            setUsers(res.data.user);
          } else {
            console.log(res.data.error_code);
            if (res.data.error_code === 999) {
              console.log(true);
              toast.error("Please Login !", {
                position: toast.POSITION.TOP_RIGHT,
              });
              localStorage.clear();
              window.location.reload();
              console.log("sdfgh");
            } else {
              // if (res.data.error_code == 999) {
              //   console.log(true);
              //   toast.error("Please Login !", {
              //     position: toast.POSITION.TOP_RIGHT,
              //   });
              //   localStorage.clear();
              //   window.location.reload();
              //   console.log("sdfgh");
              // } else {
              //   diapach(
              //     setError({
              //       error: true,
              //       message: `failed, please check again(${res.data.error_code})`,
              //     })
              //   );
              // }
            }
          }
        } else {
          // do something
          console.log("erororor", res.data.error_code);
          if (res.data.error_code == 999) {
            console.log(true);
            toast.error("Please Login !", {
              position: toast.POSITION.TOP_RIGHT,
            });
            localStorage.clear();
            window.location.reload();
            console.log("sdfgh");
          } else {
            diapach(
              setError({
                error: true,
                message: `failed, please check again(${res.data.error_code})`,
              })
            );
          }
        }
      })
      .catch((err) => {
        // do something
        diapach(
          setError({ error: true, message: `failed, please check again` })
        );
        console.log(err);
      });
  };

  const logout = () => {
    localStorage.setItem("auth", "");
    props.logout();
    // nav("/login");
  };

  return (
    <div className="b-profile">
      <div className="b-profile-all">
        <div style={{ width: "100%" }} className="b-img-cont">
          <img
            style={{
              display: "block",
              width: "80px",
              borderRadius: "50%",
              margin: "0 auto",
            }}
            src="zmall-logo.png"
            alt="zmall-logo"
          />
        </div>
        <p>
          {users && users.first_name}&nbsp;
          <MdOutlineVerified
            fill="#f12235"
            size={20}
            style={{ float: "right" }}
          />
        </p>
        <p>
          {users && users.country_phone_code}&nbsp;{users && users.phone}
        </p>
        <p>{users && users.email}</p>
        <p>{users && users.city}</p>
        <br />
        {/* <button onClick={() => setEdit(true)}>Edit</button> */}
        <div className="b-wallet-info">
          <h5>Wallet</h5>
          <p>{users && users.wallet}</p>
        </div>
      </div>
      {/* <div className="b-wall">
        <Link to="/wallet">
          <MdCreditCard style={{ float: "left" }} size={25} fill="#f12235" />
          Wallet
          <RiArrowRightSFill
            style={{ float: "right" }}
            size={25}
            fill="#f12235"
          />
        </Link>
      </div> */}

      <br />

      <button className="b-log-btn" onClick={logout}>
        Log Out
      </button>
      {edit ? (
        <ProfileEditPage edit={edit} setEdit={setEdit} users={users} />
      ) : (
        ""
      )}
    </div>
  );
}

export default Profile;
